export const GETTERS_WITHOUT_CONFIG_ERROR_MESSAGE =
  'Trying to use config getters, but League config has not been set! Are you sure you called `setConfig` at least once, or that a config object was passed to `<LeagueProvider>` at the top of your app?';

export const SET_CONFIG_UPDATER_WITHOUT_CONFIG_ERROR_MESSAGE =
  'Trying to use `setConfig` with an updater function, but League config has not been initialized! Are you sure you called `setConfig` at least once, or that a config object was passed to `<LeagueProvider>` at the top of your app?';

export const FAILED_TO_FETCH_SERVER_CONFIG_ERROR_MESSAGE =
  'Failed to fetch configuration from the server';
